import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal/Modal";
import Backdrop from "@material-ui/core/Backdrop/Backdrop";
import Grid from "@material-ui/core/Grid/Grid";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import Box from "@material-ui/core/Box";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";
import { SignUp } from "./SignUp";
import { SignIn } from "./SignIn";
import { Recovery } from "./Recovery";
import Button from "@material-ui/core/Button";

export function Alert(props) {
    return (
        <MuiAlert
            elevation={6}
            className="text-right shabnam"
            variant="filled"
            {...props}
        />
    );
}

const useStyles = makeStyles((theme) => ({
    inActive: {
        width: "100%",
        backgroundColor: "#F3F3F3",
        fontWeight: "bold",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.12)",
        borderRadius: "10px",
        color: "#656565",
        "&:hover": {
            backgroundColor: "#F3F3F3",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.20)",
        },
    },
    active: {
        backgroundColor: "#950000",
        fontFamily: "Dana-FaNum",
        fontWeight: "bold",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.12)",
        color: "#fff",
        width: "100%",
        borderRadius: "10px",
        "&:hover": {
            backgroundColor: "#950000",
        },
    },
    response: {},
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    textOrange: {
        color: "#FF9C09",
        cursor: "pointer",
        fontWeight: "bold",
    },
    paper: {
        width: "570px",
        background: "#F9F9F9",
        boxSizing: "border-box",
        borderRadius: " 10px",
        outline: "none",

        [theme.breakpoints.down(650)]: {
            width: "85%",
        },
        [theme.breakpoints.up(2560)]: {
            width: "999px",
        },

        [theme.breakpoints.down(340)]: {
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "15px",
            paddingLeft: "10px",
            paddingRight: "10px",
        },
    },
    container: {
        padding: theme.spacing(2, 4, 3),
        paddingLeft: "25px",
        paddingBottom: "50px",
        paddingRight: "25px",
    }
}));

function LoginModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [failAlert, setFailAlert] = React.useState(false);
    const [failMsg, setFailMsg] = React.useState(null);
    const [successMsg, setSuccessMsg] = React.useState(null);
    const [login, setLogin] = React.useState(false);
    const [register, setRegister] = React.useState(true);
    const [recovery, setRecovery] = React.useState(false);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);
    useEffect(() => {
        if (localStorage.getItem('openSSModal') === true) {
            setOpen(true)
            localStorage.setItem('openSSModal', false)
        }
    })
    const handleStates = (a, b, c) => {
        setRegister(a);
        setRecovery(b);
        setLogin(c);
    };

    const handleFailError = (msg) => {
        setFailAlert(true);
        setFailMsg(msg);
    };
    const handleSuccessAlert = (msg) => {
        setSuccessAlert(true);
        setSuccessMsg(msg);
    };

    const failClose = () => {
        setFailAlert(false);
    };
    const successClose = () => {
        setSuccessAlert(false);
    };
    return (
        <div>
            <Modal
                open={open}
                onClose={props.onClose}
                center
                className={classes.modal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}>
                <Fade in={open}>
                    <div className={classes.paper}>
                        <Box>
                            <Grid container spacing={0}>
                                <Grid item xs={4}>
                                    <Box mr={0} position="relative" zIndex={1002}>
                                        <Button
                                            variant="contained"
                                            className={register ? classes.active : classes.inActive}
                                            onClick={() => handleStates(true, false, false)}>
                                            ثبت نام
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={4}>
                                    <Box ml={-2} mr={0} position="relative" zIndex={1001}>
                                        <Button
                                            variant="contained"
                                            onClick={() => {
                                                handleStates(false, false, true);
                                            }}
                                            className={login ? classes.active : classes.inActive}>
                                            ورود
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid item xs={4}>
                                    <Box position="relative" zIndex={1000}>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleStates(false, true, false)}
                                            className={recovery ? classes.active : classes.inActive}>
                                            بازیابی
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <div className={classes.container}>
                            {register && (
                                <SignUp
                                    success={(msg) => handleSuccessAlert(msg)}
                                    failed={(msg) => handleFailError(msg)}
                                    loginToggle={() => handleStates(false, false, true)}
                                    onClose={props.onClose}
                                />
                            )}
                            {login && (
                                <SignIn
                                    success={(msg) => handleSuccessAlert(msg)}
                                    failed={(msg) => handleFailError(msg)}
                                    onClose={props.onClose}
                                    redirect={props.redirect}
                                />
                            )}
                            {recovery && (
                                <Recovery
                                    success={(msg) => handleSuccessAlert(msg)}
                                    failed={(msg) => handleFailError(msg)}
                                />
                            )}
                        </div>
                    </div>
                </Fade>
            </Modal>
            <Snackbar open={failAlert} autoHideDuration={3300} onClose={failClose}>
                <Alert severity="warning">{failMsg}</Alert>
            </Snackbar>
            <Snackbar
                open={successAlert}
                autoHideDuration={3300}
                onClose={successClose}
            >
                <Alert severity="success">{successMsg}</Alert>
            </Snackbar>
        </div>
    );
}


export default LoginModal;
